{
  "step": "Bước {{current}} / {{total}}",
  "back": "Quay lại",
  "useDefault": "Dùng mặc định và tiếp tục",
  "recommended": "Khuyên dùng",
  "next": "Tiếp theo",
  "finish": "Hoàn tất",
  "saving": "Đang lưu...",
  "submitError": "Không lưu được, thử lại.",
  "businessType": {
    "title": "Hình thức kinh doanh của bạn?",
    "help": "Quyết định mẫu sổ sách bạn xuất được sau này; đổi được trong Cài đặt.",
    "household": "Hộ kinh doanh",
    "unregistered": "Chưa đăng ký",
    "enterprise": "Doanh nghiệp"
  },
  "defaultChargeAbsent": {
    "title": "Buổi vắng không phép có tính tiền không?",
    "help": "Áp dụng cho học viên đóng theo buổi thêm sau này; từng em đổi được riêng.",
    "yes": "Có tính",
    "no": "Không tính"
  },
  "maxExcusedPerMonth": {
    "title": "Mỗi tháng cho nghỉ có phép tối đa mấy buổi?",
    "help": "Quá số này, buổi nghỉ tiếp theo tính như vắng không phép; học bù thì được hoàn phép.",
    "three": "3 buổi",
    "two": "2 buổi",
    "four": "4 buổi",
    "unlimited": "Không giới hạn"
  },
  "invoiceDueDay": {
    "title": "Hạn thanh toán hoá đơn?",
    "help": "Quá hạn thì hoá đơn hiện 'trễ n ngày' và vào thẻ Cần chú ý.",
    "plus7": "7 ngày sau khi gửi",
    "day5": "Ngày 5 hàng tháng",
    "day10": "Ngày 10 hàng tháng",
    "day15": "Ngày 15 hàng tháng"
  },
  "classMode": {
    "title": "Bạn tổ chức lớp kiểu nào?",
    "help": "Chỉ đặt mặc định cho các màn hình, đổi được trong Cài đặt › Hiển thị. Cả hai kiểu đều dùng chung một cách tính tiền.",
    "cohort": "Lớp học chung",
    "cohortDesc": "Cả lớp cùng một bài, học cố định vài buổi mỗi tuần. Toán, ngoại ngữ, luyện thi.",
    "individual": "Học riêng từng em",
    "individualDesc": "Mỗi em một tiến độ, xếp theo khung giờ. Nhạc cụ, mĩ thuật, kèm 1-1.",
    "presetHeading": "Kiểu này đặt sẵn",
    "presetPrimaryButton": "Nút chính",
    "presetPrimaryButtonValue": "Tạo lớp",
    "presetForm": "Form Tạo lớp",
    "presetFormCohort": "Chọn nhiều thứ trong tuần, tên lớp bắt buộc",
    "presetFormIndividual": "Một thứ trong tuần, tên lớp để trống được",
    "presetSkeleton": "Lịch cố định",
    "presetSkeletonCohort": "Lớp có từ hai khung giờ được tô màu",
    "presetSkeletonIndividual": "Giữ nền giấy, một thẻ mỗi khung giờ",
    "presetStudents": "Danh sách học viên",
    "presetStudentsCohort": "Có cột và bộ lọc Lớp",
    "presetStudentsIndividual": "Ẩn cột Lớp, bộ lọc vẫn có"
  },
  "skip": "Bỏ qua",
  "contactPhone": {
    "title": "Số Zalo của bạn?",
    "help": "Để LopHoc nhắn hỗ trợ cài đặt trong tuần đầu. Bỏ qua được, thêm sau trong Cài đặt › Tổ chức.",
    "placeholder": "0912 345 678",
    "privacy": "Chỉ LopHoc dùng để liên hệ bạn. Không hiện với phụ huynh hay học viên.",
    "invalid": "Số di động Việt Nam 10 chữ số, ví dụ 0912 345 678."
  }
}
